import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function Guarantee() {
  return <section className="py-14 bg-[#06101f] border-y border-border/30" data-id="element-88">
      <div className="px-5" data-id="element-89">
        <motion.div className="text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-90">
          <div className="w-20 h-20 mx-auto bg-primary/10 rounded-full flex items-center justify-center mb-6 relative" data-id="element-91">
            <div className="absolute inset-0 bg-primary/20 rounded-full animate-ping opacity-20" data-id="element-92"></div>
            <Shield className="w-10 h-10 text-primary" data-id="element-93" />
          </div>

          <h2 className="text-2xl font-bold text-white font-heading mb-4" data-id="element-94">
            Garantía total de 7 días
          </h2>

          <p className="text-base text-white/80 leading-relaxed" data-id="element-95">
            Si el contenido no cumple tus expectativas, devolvemos el 100% de tu
            dinero.{' '}
            <span className="text-primary font-bold" data-id="element-96">Sin preguntas.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}